import { mapKeys } from 'lodash-es'

export const BREAKFAST_MENU = 'BREAKFAST_MENU'
export const BRUNCH_MENU = 'BRUNCH_MENU'
export const DESSERTS_MENU = 'DESSERTS_MENU'
export const DIETARY_MENU = 'DIETARY_MENU'
export const DINNER_MENU = 'DINNER_MENU'
export const DRINKS_MENU = 'DRINKS_MENU'
export const EVENTS_MENU = 'EVENTS_MENU'
export const EXCLUDED_MENU = 'EXCLUDED_MENU'
export const EXTERIOR_PHOTO = 'EXTERIOR_PHOTO'
export const FESTIVE_MENU = 'FESTIVE_MENU'
export const FOOD_PHOTO = 'FOOD_PHOTO'
export const INTERIOR_PHOTO = 'INTERIOR_PHOTO'
export const KIDS_MENU = 'KIDS_MENU'
export const LUNCH_MENU = 'LUNCH_MENU'
export const MAIN_MENU = 'MAIN_MENU'
export const NOISE = 'NOISE'
export const OTHER_DOCUMENT = 'OTHER_DOCUMENT'
export const OTHER_LOCATION = 'OTHER_LOCATION'
export const OTHER_MENU = 'OTHER_MENU'
export const OTHER_PHOTO = 'OTHER_PHOTO'
export const PEOPLE_PHOTO = 'PEOPLE_PHOTO'
export const SET_MEAL_MENU = 'SET_MEAL_MENU'
export const SPECIALS_MENU = 'SPECIALS_MENU'
export const STARTERS_MENU = 'STARTERS_MENU'
export const TAKEAWAY_MENU = 'TAKEAWAY_MENU'
export const TIME_LIMITED_MENU = 'TIME_LIMITED_MENU'

export const MENU_CATEGORIES = mapKeys(
  [
    { name: 'Breakfast', value: BREAKFAST_MENU },
    { name: 'Brunch', value: BRUNCH_MENU },
    { name: 'Desserts', value: DESSERTS_MENU },
    { name: 'Dietary', value: DIETARY_MENU },
    { name: 'Dinner', value: DINNER_MENU },
    { name: 'Drinks', value: DRINKS_MENU },
    { name: 'Events', value: EVENTS_MENU },
    { name: 'Excluded', value: EXCLUDED_MENU },
    { name: 'Exterior Photo', value: EXTERIOR_PHOTO },
    { name: 'Festive', value: FESTIVE_MENU },
    { name: 'Food Photo', value: FOOD_PHOTO },
    { name: 'Interior Photo', value: INTERIOR_PHOTO },
    { name: 'Kids', value: KIDS_MENU },
    { name: 'Lunch', value: LUNCH_MENU },
    { name: 'Main', value: MAIN_MENU },
    { name: 'Noise', value: NOISE },
    { name: 'Other Document', value: OTHER_DOCUMENT },
    { name: 'Other Location', value: OTHER_LOCATION },
    { name: 'Other Menu', value: OTHER_MENU },
    { name: 'Other Photo', value: OTHER_PHOTO },
    { name: 'People Photo', value: PEOPLE_PHOTO },
    { name: 'Set Meal', value: SET_MEAL_MENU },
    { name: 'Specials', value: SPECIALS_MENU },
    { name: 'Starters', value: STARTERS_MENU },
    { name: 'Takeaway', value: TAKEAWAY_MENU },
    { name: 'Time Limited', value: TIME_LIMITED_MENU },
  ],
  'value',
)
